import React from "react";
import { useNavigate } from "react-router-dom";

import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

import logoImg from "../../images/logo/v.png";

import { GradientSpan, H1, P3 } from "../../components/theme/text/Headings";
import { ButtonGradient } from "../../components/theme/Button";

import {
  Black,
  Blue,
  White,
  gradientColors,
  NeonGreen,
} from "../../components/theme/colors";

import { auth } from "../../services/firebase.config";

const LoginBody = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding: 0 2vh;
  background: ${Black};
  position: relative;
`;

const TopContent = styled.div`
  margin-top: 30vh;
`;

const BottomLogin = styled.div`
  position: absolute;
  bottom: 250px;
  left: 2vh;
  right: 2vh;
`;

const SaveAccount = () => {
  const navigate = useNavigate(); // Navigation function
  return (
    <LoginBody>
      <Container>
        <Row>
          <Col
            lg={{ offset: 4, span: 4 }}
            md={{ offset: 3, span: 6 }}
            sm={{ offset: 2, span: 8 }}
            xs={{ span: 12 }}
            className="text-align-center"
          >
            <TopContent>
              <img
                src={logoImg}
                alt="Vibe Check Logo"
                style={{ height: "60px" }}
              />
              <P3 className="mt-20">
                <GradientSpan
                  $background={NeonGreen}
                  $transitionBackground={Blue}
                >
                  Thanks for taking a Vibe Check!
                </GradientSpan>
              </P3>
              <H1 className="mt-15" color={White}>
                Your results were sent to your <br />
                friend! 👀
              </H1>
            </TopContent>

            <BottomLogin>
              <div style={{ padding: "0 15px" }}>
                <ButtonGradient
                  width="100%"
                  $background={gradientColors["personality-check"].background}
                  $transitionBackground={
                    gradientColors["personality-check"].transitionBackground
                  }
                  onClick={() => {
                    const user = auth.currentUser;

                    if (user && user.isAnonymous) {
                      navigate("/login", { state: { linkAnonymous: true } });
                    } else {
                      navigate("/login");
                    }
                  }}
                >
                  Save your answers!
                </ButtonGradient>
              </div>
            </BottomLogin>
          </Col>
        </Row>
      </Container>
    </LoginBody>
  );
};

export default SaveAccount;
